<template>
  <div class="contentUs">
    <div class="box">
      <div class="left">
        <img src="../../static/common/adv-white-logo.png" alt="">
        <span>2019-2023©All Right Reserved VertAds</span>
      </div>
      <div class="right">
        <ul>
          <li>
            <p @click="goLayout('1')">ADVERTISERS</p>
            <p>
              <img src="../../static/contact/linkedin.png" alt="">
              <span @click="goOutLink(1)">Linkedin</span>
            </p>
          </li>
          <li>
            <p @click="goLayout('2')">AFFILIATES</p>
            <p>
              <img src="../../static//contact/facebook.png" alt="">
              <span>Facebook</span>
            </p>
          </li>
          <li>
            <p @click="goLayout('3')">EVENT & RESOURCE</p>
            <p>
              <img src="../../static/contact/twitter.png" alt="">
              <span @click="goOutLink(0)">Twitter</span>
            </p>
          </li>
          <li>
            <p @click="goLayout('4')">CONTACT</p>
            <p>
              <img src="../../static/contact/ins.png" alt="">
              <span>Instagram</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="floatBox" v-if="MenuKey == 1">
        <span class="transformBtn" @click="goLayout('4')">CONTACT US</span>
        <h3>GROW YOUR GLOBAL BUSINESS TODAY</h3>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name:'Contactus',
  data(){
    return{
      
    }
  },
  computed:{
    MenuKey(){
      return this.$store.state.menuKey;
    }
  },
  methods:{
    goLayout(e){
      this.$store.commit('setMenuKey',e);
      switch(e){
        case '1':
          this.$router.push({
            name: "Index"
          });
          break;
        case '2':
          this.$router.push({
            path:'Aboutus'
          })
          break;
        case '3':
          this.$router.push({
            name: "Details"
          });
          break;
        case '4':
          this.$router.push({
            name:'signup'
          })
          break;
      }
    },
    goOutLink(e){
      if(e){
        window.open('https://www.linkedin.com/company/vertads');
      }else{
        window.open('https://twitter.com/_Vertads');
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .contentUs{
    width: 100%;
    background-color: #362D2D;
    box-sizing: border-box;
    padding: 100px 0;
    position: relative;
    .box{
      width: 80%;
      height: 100%;
      color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      .left{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        img{
          width: 350px;
          height: auto;
          margin-bottom: 25px;
        }
        span{
          font-size: 20px;
        }
      }
      .right{
        ul{
          li{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            p{
              font-size: 14px;
              display: flex;
              align-items: center;
              cursor: pointer;
              img{
                width: 18px;
                height: 18px;
                margin-right: 20px;
              }
            }
            p:nth-child(1){
              width: 175px;
            }
          }
        }
      }
      .floatBox{
        width: 70%;
        position: absolute;
        top: -30%;
        right: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 80px 0 80px 97px;
        box-shadow:0px 0px 20px 0px rgba(112, 112, 112, 0.2);
        border-bottom-left-radius: 100px;
        background-color: #FFFFFF;
        span{
          width: 190px;
          height: 48px;
          border: 1px solid #DC1F27;
          font-size: 21px;
          color: #DC1F27;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 97px;
        }
        h3{
          font-size: 30px;
          margin: 0;
          color: #000;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .contentUs{
      width: 100%;
      background-color: #362D2D;
      box-sizing: border-box;
      padding: 50px 0 30px;
      position: relative;
      .box{
        width: 80%;
        height: 100%;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        .left{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          img{
            width: 100px;
            height: auto;
            margin-bottom: 5px;
          }
          span{
            max-width: 120px;
            font-size: 10px;
          }
        }
        .right{
          ul{
            li{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              p{
                font-size: 8px;
                display: flex;
                align-items: center;
                cursor: pointer;
                margin: 0;
                margin-bottom: 5px;
                img{
                  width: 10px;
                  height: 10px;
                  margin-right: 10px;
                }
              }
              p:nth-child(1){
                width: 90px;
              }
            }
          }
        }
        .floatBox{
          width: 85%;
          position: absolute;
          top: -30%;
          right: 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          padding: 20px 0 20px 27px;
          box-shadow:0px 0px 20px 0px rgba(112, 112, 112, 0.2);
          border-bottom-left-radius: 30px;
          background-color: #FFFFFF;
          span{
            width: 80px;
            height: 22px;
            border: 1px solid #DC1F27;
            font-size: 9px;
            color: #DC1F27;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0px;
            margin-right: 10px;
            scale: 0.9;
          }
          h3{
            font-size: 8px;
            margin: 0;
            color: #000;
          }
        }
      }
    }
  }
</style>